import { Airport } from 'models/airport';
import { TravelType } from 'models/enums/travelType';
import { RequestTripType } from 'models/enums/tripType';
import { TravelStatus } from 'models/travelStatus';

export interface SearchParams {
  destination?: Airport;
  initDate?: string;
  endDate?: string;
  tripType?: TravelType;
  distanceRestriction?: RequestTripType;
  page?: number;
  type?: SearchTypes | string;
  travelItineraryId?: string;
  travelStatus?: TravelStatus;
}

export enum SearchTypes {
  search = 'search',
  next = 'next',
  prev = 'prev',
}

export enum SearchTypesHistory {
  week = 'week',
  month = 'month',
  search = 'search',
}
export interface SearchParamsHistory extends SearchParams {
  type?: SearchTypesHistory | string;
}
